/**
 * @prettier
 */

const defaultSteps = {
  detailFront: {
    name: 'Front',
    id: 'detailFront',
    cardType: null,
    pageNumber: 0,
  },
  detailInside: {
    name: 'Inside',
    id: 'detailInside',
    cardType: null,
    pageNumber: 1,
  },
  detailBack: {
    name: 'Back',
    id: 'detailBack',
    cardType: null,
    pageNumber: 1,
  },
  envelope: {
    name: 'Envelope',
    id: 'envelope',
    cardType: 'INVITATION_ENVELOPE',
    pageNumber: 0,
  },
  recipients: {
    name: 'Guests',
    id: 'recipients',
    cardType: null,
    pageNumber: null,
  },
  addressing: {
    name: 'Addressing',
    id: 'addressing',
    cardType: null,
    pageNumber: null,
  },
  addressingPreview: {
    name: 'Addressing Preview',
    id: 'addressingPreview',
    cardType: null,
    pageNumber: null,
  },
  rsvp: {
    name: 'RSVP Card',
    id: 'rsvp',
    cardType: 'RSVP',
    pageNumber: 0,
  },
  rsvpEnvelope: {
    name: 'RSVP Envelope',
    id: 'rsvpEnvelope',
    cardType: 'RSVP_ENVELOPE',
    pageNumber: 0,
  },
  reviewPaper: {
    name: 'Review',
    id: 'reviewPaper',
  },
};

const ignoredBreadcrumbSteps = ['recipients', 'addressing', 'addressingPreview'];

// TODO: Add JSDOC
const getCustomizationNavData = (entities, unorderedTypes, lead, leadSize) => {
  const { pages: leadPageIds, type: leadType } = lead;
  const { customizations, pages } = entities;
  const orderedSteps = [];

  // Lead customizations always have a detailFront step
  orderedSteps.push({ ...defaultSteps.detailFront, cardType: leadType });

  // Check if a second page step (e.g. inside or back) is needed
  if (leadPageIds.length > 1) {
    const leadPages = leadPageIds.map(uuid => pages[uuid]);
    const pageTwo = leadPages.find(page => page.page_number === 2);

    if (pageTwo.folded) {
      // If there are elements on a folded card's second page (e.g. new Thank Yous), add inside printing
      if (pageTwo.elements.length) {
        orderedSteps.push({ ...defaultSteps.detailInside, cardType: leadType });
      }
      // Otherwise, don't show extra step for folded cards
    } else {
      // All other cards with a second page have reverse printing
      orderedSteps.push({ ...defaultSteps.detailBack, cardType: leadType });
    }
  }

  // Check if addressing steps are needed
  if (leadSize === 'postcard') {
    // If the lead customization is a postcard, add postcard addressing steps
    const postcardAddressing = { cardType: leadType, pageNumber: 1 };
    orderedSteps.push({ ...defaultSteps.recipients, ...postcardAddressing });
    orderedSteps.push({ ...defaultSteps.addressing, ...postcardAddressing });
    orderedSteps.push({ ...defaultSteps.addressingPreview, ...postcardAddressing });
  } else if (unorderedTypes.INVITATION_ENVELOPE) {
    // If there is an invitation envelope customization, add envelope addressing steps
    const invitationEnvelopeAddressing = { cardType: 'INVITATION_ENVELOPE', pageNumber: 0 };
    orderedSteps.push({ ...defaultSteps.envelope });
    orderedSteps.push({ ...defaultSteps.recipients, ...invitationEnvelopeAddressing });
    orderedSteps.push({ ...defaultSteps.addressing, ...invitationEnvelopeAddressing });
    orderedSteps.push({ ...defaultSteps.addressingPreview, ...invitationEnvelopeAddressing });
  }

  // If there is an RSVP customization, add the rsvp step
  if (unorderedTypes.RSVP) {
    orderedSteps.push({ ...defaultSteps.rsvp });
  }

  // If there is an RSVP_ENVELOPE customization, add the rsvpEnvelope step
  if (unorderedTypes.RSVP_ENVELOPE) {
    orderedSteps.push({ ...defaultSteps.rsvpEnvelope });
  }

  // TODO: For any other supported customizations, add detailFront (and detailBack if needed)

  // Always end with the reviewPaper step
  orderedSteps.push({ ...defaultSteps.reviewPaper });

  // Ordered list of step IDs to display in breadcrumbs
  const rsvpEnabled = unorderedTypes.RSVP && !customizations[unorderedTypes.RSVP].inactive;
  const breadcrumbs = orderedSteps
    .map(step => step.id)
    .filter(stepId => {
      // Remove rsvpEnvelope when RSVPs are disabled, and always remove recipients + addressing
      const skip = ignoredBreadcrumbSteps.includes(stepId) || (stepId === 'rsvpEnvelope' && !rsvpEnabled);
      return !skip;
    });

  // Object containing all step details
  const steps = orderedSteps.reduce((acc, step) => {
    acc[step.id] = step;
    return acc;
  }, {});

  return { breadcrumbs, steps };
};

export default getCustomizationNavData;



// WEBPACK FOOTER //
// ./src/cards/util/customizationNavigation.js